/**
 * Transparent Header Functionality
 * Handles transparent header state and logo swapping
 */

let originalLogoSrc = null;
let alternateLogoSrc = null;
let hasScrolled = false;
let isTransparentActive = false;

const initTransparentHeader = () => {
	const body = document.body;
	const hasTransparentHeader = body.dataset.transparentHeader === 'true';
	const alternateLogoUrl = body.dataset.alternateLogo;

	if (!hasTransparentHeader || !alternateLogoUrl) {
		return;
	}

	const navigation = document.querySelector('.block-navigation');
	const logo = document.querySelector('.block-navigation__logo');

	if (!navigation || !logo) {
		return;
	}

	// Store original logo source
	originalLogoSrc = logo.src;
	alternateLogoSrc = alternateLogoUrl;

	// Apply transparent state initially (with checks)
	checkAndApplyTransparentState();

	// Handle scroll events
	let scrollTimeout;
	window.addEventListener(
		'scroll',
		() => {
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(() => {
				handleScroll();
			}, 10);
		},
		{ passive: true }
	);

	// Handle navigation menu open/close events
	window.addEventListener('navigation-opened', removeTransparentState);
	window.addEventListener(
		'navigation-submenu-opened',
		removeTransparentState
	);
	window.addEventListener('navigation-submenu-closed', () => {
		checkAndApplyTransparentState();
	});

	// Also watch for hamburger menu clicks directly as a fallback
	const hamburgers = document.querySelectorAll(
		'.block-navigation__hamburger'
	);
	hamburgers.forEach((hamburger) => {
		hamburger.addEventListener('click', () => {
			// Small delay to ensure the active class is toggled first
			setTimeout(() => {
				if (hamburger.classList.contains('active')) {
					removeTransparentState();
				} else {
					checkAndApplyTransparentState();
				}
			}, 10);
		});
	});

	// Handle search open/close events
	window.addEventListener('navigation-search-opened', removeTransparentState);
	window.addEventListener('navigation-search-closed', () => {
		checkAndApplyTransparentState();
	});
};

const applyTransparentState = () => {
	const navigation = document.querySelector('.block-navigation');
	const logo = document.querySelector('.block-navigation__logo');

	if (!navigation || !logo || isTransparentActive) {
		return;
	}

	// Only apply if at the top of the page
	if (window.scrollY > 0) {
		return;
	}

	navigation.classList.add('is-transparent');
	document.body.classList.add('has-transparent-header');

	// Swap to alternate logo
	if (alternateLogoSrc) {
		logo.src = alternateLogoSrc;
	}

	isTransparentActive = true;
};

const removeTransparentState = () => {
	const navigation = document.querySelector('.block-navigation');
	const logo = document.querySelector('.block-navigation__logo');

	if (!navigation || !logo || !isTransparentActive) {
		return;
	}

	navigation.classList.remove('is-transparent');
	document.body.classList.remove('has-transparent-header');

	// Restore original logo
	if (originalLogoSrc) {
		logo.src = originalLogoSrc;
	}

	isTransparentActive = false;
};

const checkAndApplyTransparentState = () => {
	// Only apply transparent state if:
	// 1. At top of page (no scroll)
	// 2. No submenu is active
	// 3. Search is not active
	if (window.scrollY === 0 && !hasScrolled) {
		const navigation = document.querySelector('.block-navigation');
		const hasActiveSubmenu = document.querySelector(
			'.block-navigation-link.active'
		);
		const hasActiveSearch = navigation?.classList.contains('search-active');

		if (!hasActiveSubmenu && !hasActiveSearch) {
			applyTransparentState();
		}
	}
};

const handleScroll = () => {
	if (window.scrollY > 0) {
		hasScrolled = true;
		removeTransparentState();
	} else {
		hasScrolled = false;
		checkAndApplyTransparentState();
	}
};

export default {
	init: initTransparentHeader,
};
